var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScalapay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 32,
    viewBox: "0 0 38 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Percorso",
    fill: "#272727",
    fillRule: "evenodd",
    stroke: "none",
    d: "M 0.5 11.6 C -0.2 10.799999 -0.2 9.6 0.6 8.799999 L 8.6 0.5 C 9.4 -0.400002 10.8 -0.400002 11.6 0.5 L 17.799999 6.9 C 18.6 7.799999 20 7.799999 20.799999 6.9 L 26.700001 0.799999 C 27.5 -0.099998 28.9 -0.099998 29.700001 0.799999 L 37.700001 9 C 38.5 9.799999 38.5 11 37.799999 11.799999 L 20.799999 31.299999 C 20 32.300003 18.5 32.300003 17.6 31.299999 L 0.5 11.6 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScalapay);
export default __webpack_public_path__ + "static/media/scalapay.397782f6955a0fdb2f4421ff9fa06e45.svg";
export { ForwardRef as ReactComponent };